var $ = jQuery.noConflict();

$(function(){

    $('.faq-items__item-content').hide();

    $('.faq-items__item-title').on('click',function(){
        
        if($(this).hasClass('expand')){
            $(this).removeClass('expand');
            $(this).next().slideUp();
            $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
            $(this).attr('aria-expanded', false)
        
        } else {
            $(this).addClass('expand');
            $(this).next().slideDown();
            $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $(this).attr('aria-expanded', true)
        }

    });


}) // document ready
